// Generated by purs version 0.14.4
import * as Data_Coordinates from "../Data.Coordinates/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Addresses_Types_AddressExtra from "../Restaumatic.Addresses.Types.AddressExtra/index.js";
import * as Restaumatic_TypesGen from "../Restaumatic.TypesGen/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var StreetAddressWithApartment = function (x) {
    return x;
};
var StreetAddress = function (x) {
    return x;
};
var DeliveryAddress = function (x) {
    return x;
};
var eqStreetAddressWithApartm = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.apartmentNumber)(y.apartmentNumber) && x.city === y.city && x.street === y.street && x.streetNumber === y.streetNumber;
        };
    }
};
var eqStreetAddress = {
    eq: function (x) {
        return function (y) {
            return x.city === y.city && x.street === y.street && x.streetNumber === y.streetNumber;
        };
    }
};
var eqDeliveryAddress = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.apartmentNumber)(y.apartmentNumber) && x.city === y.city && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Coordinates.eqCoordinates))(x.coordinates)(y.coordinates) && Data_Eq.eq(Restaumatic_TypesGen.eqCountry)(x.country)(y.country) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Addresses_Types_AddressExtra.eqAddressExtra))(x.extra)(y.extra) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.floor)(y.floor) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.formattedAddress)(y.formattedAddress) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.postCode)(y.postCode) && x.street === y.street && x.streetNumber === y.streetNumber;
        };
    }
};
var newtypeStreetAddressWithApartment = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeStreetAddress = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDeliveryAddress = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldStreetAddressWithApartment = function (dictHasField) {
    return dictHasField;
};
var hasFieldStreetAddress = function (dictHasField) {
    return dictHasField;
};
var hasFieldDeliveryAddress = function (dictHasField) {
    return dictHasField;
};
var genericStreetAddressWithApartment = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showStreetAddressWithApartment = {
    show: Data_Show_Generic.genericShow(genericStreetAddressWithApartment)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "apartmentNumber";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "city";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "street";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "streetNumber";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString))(Data_Show.showString))(Data_Maybe.showMaybe(Data_Show.showString)))))({
        reflectSymbol: function () {
            return "StreetAddressWithApartment";
        }
    }))
};
var unscrambleDecodeStreetAddressWithApartment = {
    unsafeDecode: Unscramble_Generic.genericUnsafeDecode(genericStreetAddressWithApartment)(Unscramble_Generic.genericDecodeSingleConstructor(Unscramble_Generic.genericDecodeArgsSingleArg(Unscramble.decode_Record()(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "apartmentNumber";
        }
    })(Unscramble.decode_Maybe(Unscramble.decode_String))(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "city";
        }
    })(Unscramble.decode_String)(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "street";
        }
    })(Unscramble.decode_String)(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "streetNumber";
        }
    })(Unscramble.decode_String)(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var genericStreetAddress = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showStreetAddress = {
    show: Data_Show_Generic.genericShow(genericStreetAddress)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "city";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "street";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "streetNumber";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "StreetAddress";
        }
    }))
};
var unscrambleDecodeStreetAddress = {
    unsafeDecode: Unscramble_Generic.genericUnsafeDecode(genericStreetAddress)(Unscramble_Generic.genericDecodeSingleConstructor(Unscramble_Generic.genericDecodeArgsSingleArg(Unscramble.decode_Record()(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "city";
        }
    })(Unscramble.decode_String)(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "street";
        }
    })(Unscramble.decode_String)(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "streetNumber";
        }
    })(Unscramble.decode_String)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var genericDeliveryAddress = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showDeliveryAddress = {
    show: Data_Show_Generic.genericShow(genericDeliveryAddress)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "apartmentNumber";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "city";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "coordinates";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "country";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "extra";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "floor";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "formattedAddress";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "postCode";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "street";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "streetNumber";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString))(Data_Maybe.showMaybe(Data_Show.showString)))(Data_Maybe.showMaybe(Data_Show.showString)))(Data_Maybe.showMaybe(Data_Show.showString)))(Data_Maybe.showMaybe(Restaumatic_Addresses_Types_AddressExtra.showAddressExtra)))(Restaumatic_TypesGen.showCountry))(Data_Maybe.showMaybe(Data_Coordinates.showCoordinates)))(Data_Show.showString))(Data_Maybe.showMaybe(Data_Show.showString)))))({
        reflectSymbol: function () {
            return "DeliveryAddress";
        }
    }))
};
var unscrambleDecodeDeliveryAddress = {
    unsafeDecode: Unscramble_Generic.genericUnsafeDecode(genericDeliveryAddress)(Unscramble_Generic.genericDecodeSingleConstructor(Unscramble_Generic.genericDecodeArgsSingleArg(Unscramble.decode_Record()(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "apartmentNumber";
        }
    })(Unscramble.decode_Maybe(Unscramble.decode_String))(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "city";
        }
    })(Unscramble.decode_String)(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "coordinates";
        }
    })(Unscramble.decode_Maybe(Data_Coordinates.unscrambleDecodeCoordinates))(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "country";
        }
    })(Restaumatic_TypesGen.unscrambleDecodeCountry)(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "extra";
        }
    })(Unscramble.decode_Maybe(Restaumatic_Addresses_Types_AddressExtra.udecodeAddressExtra))(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "floor";
        }
    })(Unscramble.decode_Maybe(Unscramble.decode_String))(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "formattedAddress";
        }
    })(Unscramble.decode_Maybe(Unscramble.decode_String))(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "postCode";
        }
    })(Unscramble.decode_Maybe(Unscramble.decode_String))(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "street";
        }
    })(Unscramble.decode_String)(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "streetNumber";
        }
    })(Unscramble.decode_String)(Unscramble.decodeRecordNil))))))))))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = {
    sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
};
var encodeStreetAddressWithApartment = {
    encode: Foreign_Generic.genericEncode(genericStreetAddressWithApartment)(Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "StreetAddressWithApartment";
        }
    })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "streetNumber";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "street";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "city";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "apartmentNumber";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode)))))))(encodingOpts)
};
var encodeStreetAddress = {
    encode: Foreign_Generic.genericEncode(genericStreetAddress)(Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "StreetAddress";
        }
    })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "streetNumber";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "street";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "city";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(encodingOpts)
};
var encodeDeliveryAddress = {
    encode: Foreign_Generic.genericEncode(genericDeliveryAddress)(Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "DeliveryAddress";
        }
    })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "streetNumber";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "street";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "postCode";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "formattedAddress";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "floor";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "extra";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Restaumatic_Addresses_Types_AddressExtra.encodeAddressExtra))))({
        reflectSymbol: function () {
            return "country";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_TypesGen.encodeCountry)))({
        reflectSymbol: function () {
            return "coordinates";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Data_Coordinates.encodeCoordinates))))({
        reflectSymbol: function () {
            return "city";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "apartmentNumber";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode)))))))(encodingOpts)
};
var decodeStreetAddressWithApartment = {
    decode: Foreign_Generic.genericDecode(genericStreetAddressWithApartment)(Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "StreetAddressWithApartment";
        }
    })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "streetNumber";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "street";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "city";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "apartmentNumber";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeStreetAddress = {
    decode: Foreign_Generic.genericDecode(genericStreetAddress)(Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "StreetAddress";
        }
    })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "streetNumber";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "street";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "city";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeDeliveryAddress = {
    decode: Foreign_Generic.genericDecode(genericDeliveryAddress)(Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "DeliveryAddress";
        }
    })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "streetNumber";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "street";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "postCode";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "formattedAddress";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "floor";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "extra";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Restaumatic_Addresses_Types_AddressExtra.decodeAddressExtra)))())({
        reflectSymbol: function () {
            return "country";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_TypesGen.decodeCountry))())({
        reflectSymbol: function () {
            return "coordinates";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Data_Coordinates.decodeCoordinates)))())({
        reflectSymbol: function () {
            return "city";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "apartmentNumber";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    DeliveryAddress,
    StreetAddress,
    StreetAddressWithApartment,
    encodingOpts,
    genericDeliveryAddress,
    showDeliveryAddress,
    eqDeliveryAddress,
    decodeDeliveryAddress,
    unscrambleDecodeDeliveryAddress,
    encodeDeliveryAddress,
    newtypeDeliveryAddress,
    hasFieldDeliveryAddress,
    genericStreetAddress,
    showStreetAddress,
    eqStreetAddress,
    decodeStreetAddress,
    unscrambleDecodeStreetAddress,
    encodeStreetAddress,
    newtypeStreetAddress,
    hasFieldStreetAddress,
    genericStreetAddressWithApartment,
    showStreetAddressWithApartment,
    eqStreetAddressWithApartm,
    decodeStreetAddressWithApartment,
    unscrambleDecodeStreetAddressWithApartment,
    encodeStreetAddressWithApartment,
    newtypeStreetAddressWithApartment,
    hasFieldStreetAddressWithApartment
};
//# sourceMappingURL=index.js.map
